<template>
  <div>
    <router-link
      :to="{ name: 'spot-meu-agente' }"
      class="sf-trader-back"
    >
      <feather-icon
        icon="ArrowLeftIcon"
        size="15"
      />
      {{ $t('Meus agentes') }}
    </router-link>

    <b-tabs
      pills
    >
      <b-tab>
        <template #title>
          <feather-icon icon="UserIcon" />
          <span>{{ $t('spot.meuAgente.sobreBtn') }}</span>
        </template>
        <b-card>
          <b-row>
            <b-col
              cols="12"
              xl="9"
              lg="8"
              md="7"
            >
              <meu-agente-edit-tab-profile />
            </b-col>
          </b-row>
        </b-card>
      </b-tab>
      <b-tab active>
        <template #title>
          <feather-icon icon="SettingsIcon" />
          <span>{{ $t('spot.meuAgente.configurarBtn') }}</span>
        </template>
        <meu-agente-edit-tab-operacao />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import {
  BTabs, BTab, BCard, BRow, BCol,
} from 'bootstrap-vue'
import store from '@/store'
import MeuAgenteEditTabProfile from './MeuAgenteEditTabProfile.vue'
import MeuAgenteEditTabOperacao from './MeuAgenteEditTabOperacao.vue'
import meuAgenteStoreModule from './meuAgenteStoreModule'

const MEU_AGENTE_SPOT_STORE_MODULE_NAME = 'meu-agente-spot'

export default {
  components: {
    MeuAgenteEditTabProfile,
    MeuAgenteEditTabOperacao,
    BTabs,
    BTab,
    BCard,
    BRow,
    BCol,
  },

  created() {
    if (!store.hasModule(MEU_AGENTE_SPOT_STORE_MODULE_NAME)) store.registerModule(MEU_AGENTE_SPOT_STORE_MODULE_NAME, meuAgenteStoreModule)
  },

  beforeDestroy() {
    if (store.hasModule(MEU_AGENTE_SPOT_STORE_MODULE_NAME)) store.unregisterModule(MEU_AGENTE_SPOT_STORE_MODULE_NAME)
  },

}
</script>

<style lang="scss" scoped>
/* Voltar (link acima das tabs, no padrão Soulf) */
.sf-trader-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 16px;
  font-family: 'Geist', sans-serif;
  font-weight: 500;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.55);
  text-decoration: none;

  &:hover { color: #fff; text-decoration: none; }
  .feather { stroke-width: 1.5; }
}

/* Tabs do trader no padrão Soulf (wrapper pill + aba ativa #1C1C1E) */
::v-deep .nav-pills {
  display: inline-flex;
  gap: 3px;
  background: #0F0F11;
  border: 1px solid rgba(255, 255, 255, 0.10);
  border-radius: 10px;
  padding: 3px;
  margin-bottom: 20px;
}
::v-deep .nav-pills .nav-item { margin: 0; }
::v-deep .nav-pills .nav-link {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 7px 16px;
  border-radius: 7px;
  font-family: 'Geist', sans-serif;
  font-weight: 600;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.55);

  .feather { width: 15px; height: 15px; stroke-width: 1.5; }
}
::v-deep .nav-pills .nav-link.active {
  background: #1C1C1E !important;
  background-image: none !important;
  color: #fff !important;
  box-shadow: none !important;
}
</style>
